import styled, { keyframes } from 'styled-components';
import { Colors } from '~/config/Colors';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  /* background: rgba(255, 255, 255, 0.05); */
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  transition: all 0.3s ease;

  width: 100%;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const SkeletonCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  /* background: rgba(255, 255, 255, 0.05); */
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardTitle = styled.p`
  font-size: 0.85rem;
  color: ${Colors.text_Color_1};
  margin: 0;
  font-weight: 500;
`;

export const CardSubtitle = styled.p`
  font-size: 0.7rem;
  color: ${Colors.Color6};
  margin: 0;
  font-weight: 400;
  opacity: 0.8;

  margin-top: -8px;
`;

export const SkeletonTitle = styled.div`
  height: 14px;
  width: 100px;
  border-radius: 4px;
  background: ${localStorage.getItem('tema') == 'E'
    ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
    : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const CardValue = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  color: ${props => props.color || '#fff'};
`;

export const SkeletonValue = styled.div`
  height: 24px;
  width: 40px;
  border-radius: 4px;
  background: ${localStorage.getItem('tema') == 'E'
    ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
    : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const CardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => (props.color ? `${props.color}20` : 'rgba(255, 255, 255, 0.1)')};

  i {
    font-size: 20px;
    color: ${props => props.color || '#fff'};
  }
`;

export const SkeletonIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${localStorage.getItem('tema') == 'E'
    ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
    : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
`;
